// extracted by mini-css-extract-plugin
export default {"icon":"styles__icon___RswIN"};